export enum InfluencerSuggestionState {
  PROCESSING = 0,
  SINGLE_SUGGESTION = 1,
  MULTIPLE_SUGGESTIONS = 2,
  NOT_FOUND = 3,
  ERROR = 4,
}
export class InfluencerSuggestion {
  influencerId: number;
  profilePicture: string;
  influencerName: string;
  groupId: number;
  companyId: number;
  domain: string;
  country: any;
  countryCode: string;
  numberOfPosts: number;
  numberOfFollowers: number;
  description: string;
  channels: any;
  reach: number;
  impact: number;
  engagement: number;
  impression: number;
  platforms: string;
  topMentions: string;
  id: number;
  name: string;
  action: string;

  status: string;

  state: InfluencerSuggestionState;
}



// WEBPACK FOOTER //
// ./src/models/influencer-suggestion.ts